import { Text } from '@wework/dieter-ui'
import classnames from 'classnames'
import React, { useState } from 'react'
import css from './MetricDisplay.module.scss'

export default function MetricDisplay({
  value,
  midFix,
  className,
}: {
  value: number
  midFix?: string
  className?: string
}) {
  const [metric, setMetric] = useState('sqft')
  if (!value) return null
  const getMetric = () => {
    if (metric === 'sqft') return 'ft²'
    else return 'm²'
  }
  const getMetricValue = () => {
    if (metric === 'sqft') return value.toFixed(2)
    else return (value * 0.092903).toFixed(2)
  }

  return (
    <Text
      size="tiny"
      primary
      className={classnames(css.metricText, className)}
      onClick={() => (metric === 'sqft' ? setMetric('m') : setMetric('sqft'))}
    >
      {getMetricValue()} {midFix} {getMetric()}
    </Text>
  )
}
